module.exports = __webpack_public_path__ + "img/noDataChart.34470eeb.svg";